import { Routes,  Route } from "react-router-dom"

import Layout from "./Layout"
import Login from "./screens/Login/Login"

import ProyectosRoutes from "./screens/Proyectos/ProyectosRoutes"
import VentasRoutes from "./screens/Ventas/VentasRoutes"
import UsuariosRoutes from "./screens/Usuarios/UsuariosRoutes"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { checkToken } from "./datastore/actions/usuarioActions"
import CanjesRoutes from "./screens/Canjes/CanjesRoutes"
import ReportesRoutes from "./screens/Reportes/ReportesRoutes"



const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(checkToken())
  }, [])

  return(
    <Layout>
      <Routes>
        <Route path="/Proyectos/*" Component={ProyectosRoutes} />
        <Route path="/Ventas/*" Component={VentasRoutes} />
        <Route path="/Reportes/*" Component={ReportesRoutes} />
        <Route path="/Usuarios/*" Component={UsuariosRoutes} />
        <Route path="/Canjes" Component={CanjesRoutes} />
        <Route path="/Login" Component={Login} />
      </Routes>
    </Layout>
  )
}

export default App